import React, { Component } from 'react'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'
import BookmarkHeaderSection from '../components/bookmarks/bookmark_videos/BookmarkHeaderSection'
import BookmarkPracticeQuestionsSection from '../components/bookmarks/practice_questions/BookmarkPracticeQuestionsSection'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";

const FETCH_SUBJECTS = gql`
  query($student_user_exam_id: Int!,
        $exam_id: Int,
        $class_id: Int) {
        getSubjects(student_user_exam_id: $student_user_exam_id,
        exam_id: $exam_id,
        class_id: $class_id){
            id
            subject
            studentChapters{
                id
                chapter
                topics{
                    id
                    topic
                    practice_percentage
                }
                class
                weightage
                total_questions
                attempted_questions
                error_questions
            }
            practice_percentage
        }
    }
    
`;

const FETCH_GLOBALS = gql` 
query($student_user_exam_id: Int!) {
    studentGlobals(student_user_exam_id: $student_user_exam_id){
        tags{
            id
            tag
            type
            count
        }
        contentTypes{
            id
            customcontent
        }
    }
}

`;


// Inline shimmer skeleton (filter bar + stacked cards) shown while loading.
const BookmarkExamQuestionsShimmer = () => (
    <div className="py-4">
        <div className="d-flex flex-wrap mb-4">
            {[0, 1, 2, 3].map(i => <div key={i} className="rz-shimmer mr-2 mb-2" style={{ width: '90px', height: '34px', borderRadius: '20px' }} />)}
        </div>
        {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="rz-skel-card border-0 mb-3">
                <div className="rz-shimmer rz-skel-line" style={{ width: '35%' }} />
                <div className="rz-shimmer rz-skel-line sm" style={{ width: '95%' }} />
                <div className="rz-shimmer rz-skel-line sm" style={{ width: '85%' }} />
                <div className="d-flex mt-3">
                    <div className="rz-shimmer rz-skel-btn mr-2" style={{ width: '100px' }} />
                    <div className="rz-shimmer rz-skel-btn" style={{ width: '100px' }} />
                </div>
            </div>
        ))}
    </div>
);

class BookmarkPracticeQuestions extends Component {
    constructor(props) {
        super(props)
        let tagid = "";
        if ((props.history.location.state || {}).tagid != "") {
            tagid = (props.history.location.state || {}).tagid;
        }

        let subjectid = 0;
        if ((props.history.location.state || {}).subjectid != "") {
            subjectid = (props.history.location.state || {}).subjectid;
        }
        this.state = {
            toggled: "wrapper sidebar-enable",
            subjectId: subjectid,
            chapterId: 0,
            tags: tagid
        }

    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
         if (toggled === "wrapper") {
             this.setState({toggled:"wrapper sidebar-enable"});
             Cookies.set("toggle", "wrapper sidebar-enable");
         } else {
             this.setState({toggled:"wrapper"});
             Cookies.set("toggle", "wrapper");
         }
     };
    handleSelectInputChange = (name, value) => {
        console.log("handleSelectInputChange", "name", name, "value", value);
        this.setState({ [name]: value,tags:"" });
    }
    TaghandleSelectInputChange = e => {
        //console.log("TaghandleSelectInputChange", e);
        let tagsValues = Array();
        if (e != null) {
            for (let i = 0; i < e.length; i++) {
                const tagval = e[i];
                tagsValues.push(tagval.value);
            }
            this.setState({
                tags: tagsValues.toString()
            });
        }
        //console.log("tagsValues", tagsValues);

    }
    render() {

        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");
        const getSubjects = this.props.getSubjects;
        const loading2 = getSubjects.loading;
        const error2 = getSubjects.error;

        const studentGlobals = this.props.studentGlobals;
        const loading3 = studentGlobals.loading;
        const error3 = studentGlobals.error;

        if (error2 != undefined || error3 != undefined) {
            alert("Server Error. " + error2.message + error3.message);
            return null;
        }
        return (

            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    
                    <AsideNavbar onClick={() => this.menuToggler()}/>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        {(loading2 == true) && (<BookmarkExamQuestionsShimmer />)}
                        {
                            !loading2 && (
                                <React.Fragment>
                                    <BookmarkHeaderSection
                                        type="bookmark"
                                        ctype="exam"
                                        studentGlobals={studentGlobals.studentGlobals}
                                        getSubjects={getSubjects.getSubjects}
                                        phandleSelectInputChange={this.handleSelectInputChange}
                                        pTaghandleSelectInputChange={this.TaghandleSelectInputChange}
                                        stateData={this.state}
                                        
                                    />
                                    <BookmarkPracticeQuestionsSection
                                        getData={this.props.history.location.state || {}}
                                        studentGlobals={studentGlobals.studentGlobals}
                                        stateData={this.state}
                                        contentType="98"
                                        
                                    />
                                </React.Fragment>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}


export default
withRouter(compose(
        graphql(FETCH_SUBJECTS,
            {
                options: props => ({
                    variables: {
                        student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                    },
                }), name: "getSubjects"
            }),
        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                    },
                }), name: "studentGlobals"
            })
    )(BookmarkPracticeQuestions));
